var _defs, _rect, _path, _circle, _circle2, _circle3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 520,
    viewBox: "0 0 720 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1E4BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E64DA"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 520,
    rx: 48,
    fill: "#F6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 150C180 40 360 40 430 150C500 260 640 260 680 160",
    stroke: "url(#g1)",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 150,
    r: 26,
    fill: "#1E4BBA",
    opacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 150,
    r: 30,
    fill: "#1E64DA",
    opacity: 0.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 210,
    r: 22,
    fill: "#1E4BBA",
    opacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,260)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 160,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#E1E9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 220,
    height: 12,
    rx: 6,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 54,
    width: 360,
    height: 10,
    rx: 5,
    fill: "#F1F4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 78,
    width: 300,
    height: 10,
    rx: 5,
    fill: "#F1F4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 108,
    width: 180,
    height: 10,
    rx: 5,
    fill: "#E8EEFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.36ee4dc548160a4d9b8259791395b22c.svg";
export { ForwardRef as ReactComponent };